import React, { useState, useRef, Fragment } from 'react';
import './slideTypes.less'
import ToolTip from 'react-portal-tooltip'
import ReactTooltip from "react-tooltip";
import Modal from "components/common/modal";
import { useOnClickOutside } from 'components/common/hooks'
import { setMapConfigMode } from 'actions/livefeed/steerpathMapActions'

const SlideTypesAdd = ({ dispatch, slideType, summaryPageIndex, locationsListIndex, addSlideHandle }) => {
    const [ddVisible, setDdVisible] = useState(false)
    const summaryInfoModal = useRef(null)
    const locationListInfoModal = useRef(null)
    const slideAdd = useRef(null)

    function addSlideTypeHandle(e, type) {
        if (slideType === "slideshow") {
            // prevent duplicate dispatch
            let mapConfigMode = "user_input"
            dispatch(setMapConfigMode(mapConfigMode))
        }
        e.stopPropagation();
        e.preventDefault();
        addSlideHandle(e, type)
        setDdVisible(false)
    }
    useOnClickOutside(slideAdd, () => {
        ddVisible && setDdVisible(false)
    });

    let noSumPage = summaryPageIndex === undefined
    let noLocationsListPage = locationsListIndex === undefined
    return (
        <Fragment>
            <div ref={slideAdd} className="slide slide_add">
                <i
                    id="slide-type"
                    onClick={(e) => (noSumPage || noLocationsListPage) ? setDdVisible(!ddVisible) : addSlideHandle(e, "slideshow")}
                    className="font-icon icon-addicon"
                />
                <ReactTooltip id="slide_add" place="right" type="dark" effect="solid" />
            </div>
            <ToolTip
                group={"add-slide-type"}
                active={ddVisible} position="right" arrow="center"
                parent={"#slide-type"}
                style={{
                    style: {
                        background: "white",
                        padding: 0,
                        boxShadow: "0px 4px 6px rgba(0,0,0,.3)",
                        borderRadius: 0
                    },
                    arrowStyle: {
                        color: 'white',
                        borderColor: false
                    }
                }}
                tooltipTimeout={100}
            >
                <div className="slide-types">
                    <div className="slide-types__header">Add slide type</div>
                    {noSumPage &&
                        <span className="slide-types__option"
                            onClick={(e) => addSlideTypeHandle(e, "summary")}>Summary slide
                         <i onClick={(e) => {
                                e.stopPropagation();
                                summaryInfoModal.current.open()
                            }}
                                className="summary_info font-icon icon-infoIcon" />
                        </span>
                    }
                    {(!noSumPage && noLocationsListPage) &&
                        <span className="slide-types__option"
                            onClick={(e) => addSlideTypeHandle(e, "locationsList")}>Locations List slide
                         <i onClick={(e) => {
                                e.stopPropagation();
                                locationListInfoModal.current.open()
                            }}
                                className="summary_info font-icon icon-infoIcon" />
                        </span>
                    }
                    <span className="slide-types__option"
                        onClick={(e) => addSlideTypeHandle(e, "slideshow")}>Slide show</span>
                </div>
            </ToolTip>

            <Modal
                disableCloseButton={true}
                ref={locationListInfoModal}
                clickButton={() => locationListInfoModal.current.close()}
                header="Locations List Slide"
                buttonText="Got it"
                buttonClass="btn-success"
                entry={null}
            >
                <p style={{ textAlign: "left" }}>
                    Locations List slide page will list all locations chosen on the summary slide page<br />
                    You can delete this slide and add it later
               </p>
            </Modal>
            <Modal
                disableCloseButton={true}
                ref={summaryInfoModal}
                clickButton={() => summaryInfoModal.current.close()}
                header="Summary Slide"
                buttonText="Got it"
                buttonClass="btn-success"
                entry={null}
            >
                <p style={{ textAlign: "left" }}>
                    Summary slide page will contain overall information about the slides.<br />
                    When using summary slide page, the locations need to be chosen in order to display on slide show, if omit, the slide show will use default locations<br />
                    When deleting this slide, it will also delete List Slide page if exists
               </p>
            </Modal>
        </Fragment>
    );
}

export default SlideTypesAdd;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/SlidesContainer/SlideTypesAdd/index.jsx